/* eslint-disable no-console */
import { Injectable, inject } from '@angular/core';
import { Logger } from '../../interfaces/Logger';
import { GlobalLogVisualizerService } from '../../../shared/services/global-log-visualizer/global-log-visualizer.service';
import { environment } from 'src/environments/environment';
import { AppContextService } from 'src/app/shared/services/app-context/app-context.service';
import { ENVIRONMENT_NAME } from 'src/environments/environment-name.enum';

@Injectable({
  providedIn: 'root',
})
export class LoggerConsoleService implements Logger {
  private readonly globalLogVisualizerService = inject(
    GlobalLogVisualizerService
  );
  private readonly appContextService = inject(AppContextService);

  private isEnabled = environment.isLoggerEnabled;

  info(message: string): void {
    if (this.isEnabled) {
      console.info(message);
    }
  }

  warning(warning: string): void {
    if (this.isEnabled) {
      console.warn(warning);
    }
  }

  error(error: Error, customData?: unknown): void {
    if (this.isEnabled) {
      if (!customData) {
        console.error(error);

        this.globalLogVisualizerService.addLog(JSON.stringify(error));

        return;
      }

      error.message = `${error.message} [Organization: ${this.appContextService.organizationName}] [Service: ${this.appContextService.serviceId}] [Device: ${this.appContextService.deviceName}]`;

      this.globalLogVisualizerService.addLog(`${error}:`, customData);

      console.error(error, customData);
    }
  }

  debug(message: string, customData?: unknown): void {
    if (this.isEnabled) {
      if (!customData) {
        if (environment.name !== ENVIRONMENT_NAME.prod) {
          console.debug(message);
        }

        this.globalLogVisualizerService.addLog(message);

        return;
      }

      this.globalLogVisualizerService.addLog(`${message}:`, customData);

      if (environment.name !== ENVIRONMENT_NAME.prod) {
        console.debug(message, customData);
      }
    }
  }
}
